import { render, staticRenderFns } from "./MessageWindow.vue?vue&type=template&id=19a3bffc&scoped=true&"
import script from "./MessageWindow.vue?vue&type=script&lang=js&"
export * from "./MessageWindow.vue?vue&type=script&lang=js&"
import style0 from "./MessageWindow.vue?vue&type=style&index=0&id=19a3bffc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a3bffc",
  null
  
)

export default component.exports